import { useParams } from "react-router-dom";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { Sites } from "data/utils/globals";
import useGetItem from "./hooks/useGetItem";
import useUpdate from "./hooks/useUpdate";
import { path, SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { Prices } from ".";

function Update() {
  const id = Number(useParams()?.id);

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath={path}
      hideDeleteButton
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
      updatePermission={Prices.Permissions.edit}
      deletePermission={Prices.Permissions.delete}
    />
  );
}

export default Update;
